/**
 * This file is created manually
 * You can change the content
 *
 */

import Lead from './typography/Lead'
export * from './typography/Lead'
export default Lead
